<template>
  <div className="page-body">
    <img src="@/assets/images/16.png" class="top-img"    />

<!--    <img src="@/assets/images/top.png" class="top-img"  />
    <van-swipe ref="carouselRef" :autoplay="9000" indicator-color="white">

      <van-swipe-item v-for="(item, index) in goods.goodsImgs" :key="index" class="device">
        <img class="img-fluid" :src="item" alt="" />
      </van-swipe-item>
    </van-swipe>-->

    <div className="dyxs_page">
      <div>
        <div className="dyxs_page-hot">
          <!--      <img src="https://cdntuia.xmdati.cn/dexuan/activities/tuia/tui.png" alt="" />-->
          <el-tag  type="primary"  color="#5698F5"  :size="'mini'"  style="color: #FFFFFF" >大陆国行</el-tag>
          <el-tag  color="" type="primary"  effect="plain" :size="'mini'"    :hit="true">至尊赏品</el-tag>
          <el-tag  color="" type="primary"  effect="plain"  :size="'mini'"   :hit="true">国行正版苹果16</el-tag>
        </div>
        <div  style="margin-left: 20px;" >
          <H4>至尊商品 Apple/苹果 iphone16</H4>

        </div>

<!--        <div className="dyxs_page-goods">
          <img :src="data.blindBoxImg" />
          <div className="goods-detail">
            <div className="title">{{ data?.blindBoxName}}</div>
             <div className="box-price">
              <div className="box-price-prix">
                <span>¥</span>
              </div>
              {{`${data?.price?.toFixed(2)}`}}
              <div className="fontSize">
                <span>开盒价</span>
              </div>
            </div>
          </div>
        </div>-->
<!--        <div className="dyxs_page-goodsPirce">
          <div className="item">
            <div className="item-text">
              <img src="https://cdntuia.xmdati.cn/dexuan/activities/tuia/zan.png" alt="" />
              奖励开盒价：
            </div>
            <div className="item-text4">
              <span>¥{{ `${data?.price?.toFixed(2)}` }}</span>
            </div>
          </div>
        </div>-->
      </div>
<!--      <Submit :data="data" />-->

      <div>
        <div className="dyxs_page-submit" @click="download">下载领取</div>
      </div>
      <div style="display: flex;flex-direction: row;align-items: center;justify-content: center" >
      <img  src="@/assets/images/image@1x.png"  style="width: 36px;height: 37px;" />
        <h2>更多好物等你来！</h2>
        <img  src="@/assets/images/image@1x.png"  style="width: 23px;height: 24px;transform: rotate(180deg);margin-top: 30px;" />
      </div>
      <div style="display: flex;flex-direction: row;overflow: hidden;  box-sizing: border-box;margin-left: 20px;" >
        <div class="card  card-goods"  v-for="(goods)  in goodsList" >
          <img  :src="goods.goodsImgs[0]" />
        </div>

      </div>
      <div  style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
        <div class="user-card"   v-for="(user)  in userList" >
          <div class="user-card-title" >
           <div> {{user.nikeName}}</div>
            <div> {{user.addr}}</div>

          </div>
          <div class="user-card-content" >
            <div> {{user.desc}}</div>
            <div>领取成功 <img src="@/assets/images/dui.png" /> </div>
            <div style="color: grey" > {{user.time}}</div>
          </div>

        </div>
      </div>



      <Footer />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Comment from '@/components/Comment.vue'
import HotImg from '@/components/HotImg.vue'
import Footer from '@/components/Footer.vue'
import { getListBoxApi, getListGoodsApi,getVersionInfo } from '@/api/home'
import { Result } from '@/utils/typings'
import {judgePhoneType, PhoneReg} from "@/utils/tools";
import {Toast} from "vant";
import {useRoute, useRouter} from 'vue-router'
import {bxmReceive, visitor} from "@/api/advAgency";
import Time from "@/components/Time.vue";
const router = useRouter()

const data = ref<{
  backImg?: string
  blindBoxImg?: string
  price:number;
  [key: string]: any
}>({})

const goodsList = ref([])
const userList  = ref<any>([{
  nikeName:'风忽视**北',
  desc:'超级幸运～～抽中Apple',
  addr:'大连',
  time:'1分钟前'
},
  {
    nikeName:'SYZ**H',
    desc:'超级幸运～～抽中红包',
    addr:'北京',
    time:'1分钟前'
  },
  {
    nikeName:'哈哈哈**包',
    desc:'超级幸运～～抽中手机',
    addr:'杭州',
    time:'1分钟前'
  },
  {
    nikeName:'江南不**光',
    desc:'超级幸运～～抽中行李箱',
    addr:'上海',
    time:'1分钟前'
  },


])
const  bxm_id = ref('');
const adv_id = ref('0');
let isInitSuccess = ref(false);
const versionInfo = ref({version:'',publishTime:''});
const show = ref(false)


async function getListApi() {

}

async function getGoodsApi() {
  const res: Result = await getListGoodsApi()
  goodsList.value = res.result.records || {}
}



const visitorFun = async () => {
  await visitor({pageId: 'down-ad-16', rushPurchaseId: adv_id.value})
}

const download = () => {
  if(isInitSuccess.value){
    /// 请求后台激活
    bxmReceive({adid:bxm_id.value,advertiserId: adv_id.value,callback:"https://openlog.bianxianmao.com/inads/s.gif?mt=8&conversion_type=1&bxmid="+bxm_id.value});
    // 判断 android ios 下载
    const { isAndroid } = judgePhoneType();
    if (isAndroid) {
      ShareTrace.preDownload(function () {
        window.location.href = versionInfo.value.publishUrl;
      });
    } else {
      ShareTrace.download();
    }

  }else{
    //如果初始化失败建议自己指定下载地址，虽然不能获取安装参数但是不会影响用户的下载
    window.location.href = versionInfo.value.publishUrl;
  }
}
function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase()
  console.log(ua);
  //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

function _getVersionInfo(){
  getVersionInfo({"clientVersion":"android"}).then(res=>{
    versionInfo.value = res.result;
  })
}

onMounted(() => {
  //getListApi()
  if (isWeiXin()) {
    show.value = true
  }
  _getVersionInfo()

  ShareTrace.init({
    appkey: 'cc9f8075cfee88af', //分配的appkey
    // param: 'CUSTOM PARAMS', //自定义参数，如果不设置默认会取url携带的参数
    success: function () {
      isInitSuccess.value = true;
    }
  });


  const route = useRoute();
  if(route.query.bxm_id){
    bxm_id.value = route.query.bxm_id;
  }
  if(route.query.adv_id){
    adv_id.value = route.query.adv_id;
  }
  visitorFun();
  getGoodsApi();

})
</script>
<style lang="scss" scoped>
.countdown {
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 18px;
  justify-content: space-between;
  width: 126px;
  margin-left: 8px;
  font-size: 27px;
  .countdown-number {
    text-align: center;
    width: 33px !important;
    height: 33px;
    line-height: 33px;
    background: #fff;
    border-radius: 2px;
    color: #5698F5;
    font-size: 18px;
    font-family: PingFang;
    font-weight: 800;
    span {
      line-height: 33px;
      color: #5698F5;
      font-size: 19px;
      font-family: PingFang;
      font-weight: 800;
    }
  }
}

.box-price-prix {
  font-size: 20px;
  display: inline-block;
}
.item-text {
  display: flex;
  align-items: center;
}
.item-text1 {
  color: #666;
}
.item-text2 {
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  color: #666;
  display: flex;
  justify-content: flex-end;
}
.item-text4 {
  color: #5698F5;
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  display: flex;
  justify-content: flex-end;
}

.item-text6 {
  color: #5698F5;
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
}
.pay-left {
  display: flex;
  align-items: center;
  height: 41px;
  .pay-tips {
    height: 20px;
    display: flex;
    align-items: flex-end;
  }
}
.notice-p {
  color: #5698F5;
  white-space: nowrap;
  text-align: center;
  font-size: 18px;
  line-height: 30px;
}

.page-body {
  background-color: var(--UI-BG-0);
  color: var(--UI-FG-0);
}
.top-img {
  width: 100%;
  height: 375px;
}

.device {
  width: 100%;
  height: 260px;
  display: flex;
}

.img-fluid {
  margin: 0 auto;
  height: 260px;
}

.card-goods{
  width: 80px;
  height: 80px;
  background-color: #fff5f1;
  margin-right: 6px;
  img{

    width: 74px;
    height: 74px;
  }

}
.user-card{
  width: 337px;
  height: 72px;
  border-radius: 4px;
  opacity: 1;

  box-sizing: border-box;
  /* 分割线 */
  border: 1px solid #E6E6E6;
  margin-top: 20px;
  padding: 10px;
  .user-card-title,.user-card-content{
    display: flex;
    flex-direction: row;
    justify-content: space-between;

  }
  .user-card-content{
    margin-top: 10px;
    font-size: 12px;

  }
}


</style>
